import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { inject, observer } from 'mobx-react';
import { Indication2, LocationFlag } from './styled';

@inject('onboardingStore')
@observer
class LocationSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // @todo onboarding delete this after we have more locations
      location: 'UNITED_STATES',
    };
  }

  handleChange = value => {
    this.props.handleChoice(value);
    this.setState({
      location: value,
    });
  };

  render() {
    const { location } = this.state;
    const { formatCss } = this.props;

    return (
      <div
        css={css`
          ${formatCss};
        `}
      >
        <Indication2 />
        <Row
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '10px',
          }}
        >
          <LocationFlag
            type="flags/round/us/us"
            highlighted={location === 'UNITED_STATES'}
            clickHandler={() => this.handleChange('UNITED_STATES')}
          />
          {/* <LocationFlag */}
          {/* type="flags/round/germany/germany" */}
          {/* highlighted={location === 'GERMANY'} */}
          {/* clickHandler={() => this.handleChange('GERMANY')} */}
          {/* /> */}
          <LocationFlag
            type="flags/round/uk/uk"
            highlighted={location === 'UNITED_KINGDOM'}
            clickHandler={() => this.handleChange('UNITED_KINGDOM')}
          />
          {/* <LocationFlag */}
          {/* type="flags/round/italy/italy" */}
          {/* highlighted={location === 'ITALY'} */}
          {/* clickHandler={() => this.handleChange('ITALY')} */}
          {/* /> */}
        </Row>
      </div>
    );
  }
}

LocationSelector.propTypes = {
  handleChoice: PropTypes.func,
};

export default LocationSelector;
